<div class="table-header">
  <div class="actions" style="display: flex; justify-content: flex-end; align-items: center">
    <!-- <p-dropdown
      [options]="countries"
      [(ngModel)]="selectedCountry"
      placeholder="Select Country"
      [filter]="true"
      filterBy="label"
      [ngStyle]="{ width: '250px', 'margin-right': '10px' }"
    >
    </p-dropdown> -->

    <p-multiSelect [options]="countries" [(ngModel)]="selectedCountries" [filter]="true" filterBy="label"
      defaultLabel="Choose Country" [ngStyle]="{ 'min-width': '250px', 'width': 'auto' }">
    </p-multiSelect>

    <button pButton type="button" icon="pi pi-plus" label="Add Country" (click)="addCountry()"
      [disabled]="!selectedCountries.length" style="margin-right: 30px;"></button>
  </div>
</div>
<div class="mat-elevation-z8">
  <div class="table-responsive text-center justify-content-center" style="
      font-size: 14px;
      margin-bottom: 20px;
      text-align: center;
      vertical-align: center;
    ">

    <p-table #dt1 dataKey="id" [value]="providerCountries" [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
      [scrollable]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10, 25, 50]"
      [globalFilterFields]="['phone_code', 'country_name', 'acronym', 'currency_type']">
      <ng-template pTemplate="caption">
        <div class="table-header float-right">
          <div class="ui-table-globalfilter-container">
            <input type="text" pInputText size="50" placeholder="Search"
              (input)="dt1.filterGlobal($event.target.value, 'contains')" style="width: 250px; margin-left: 75%" />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width:auto;text-align: center;" pSortableColumn="phone_code">
            <b>Phone Code</b><p-sortIcon field="phone_code"></p-sortIcon>
          </th>
          <th style="width:auto;text-align: center;" pSortableColumn="country_name">
            <b>Country Name</b><p-sortIcon field="country_name"></p-sortIcon>
          </th>
          <th style="width:auto;text-align: center;" pSortableColumn="acronym">
            <b>Acronym</b><p-sortIcon field="acronym"></p-sortIcon>
          </th>
          <th style="width:auto;text-align: center;" pSortableColumn="currency_type">
            <b>Currency Type</b><p-sortIcon field="currency_type"></p-sortIcon>
          </th>
          <th>
            <b>Delete</b>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-country>
        <tr>
          <td style="width:auto;text-align: center;">{{ country.phone_code }}</td>
          <td style="width:auto;text-align: center;">{{ country.country_name }}</td>
          <td style="width:auto;text-align: center;">{{ country.acronym }}</td>
          <td style="width:auto;text-align: center;">{{ country.currency_type }}</td>
          <td style="width:auto;text-align: center;">
            <p-button icon="pi pi-trash" label="Delete" (click)="deleteCountry(country.id)"></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="ui-g-12">
    <app-error-messages [api_result]="this.providercountries.create_api_result"></app-error-messages>
    <app-error-messages [api_result]="this.allcountries.create_api_result"></app-error-messages>
    <app-error-messages [api_result]="this.addcountries.create_api_result"></app-error-messages>
    <app-error-messages [api_result]="this.deletecountries.create_api_result"></app-error-messages>
  </div>
</div>